import React from 'react';
import { SubmitButton, AfterSubmitFunc, usePopupManager } from 'ui-builder';
import BaseSmsTaskForm from './BaseSmsTaskForm';
import { PopupForm } from 'features/nekst-widgets';
import { PlanTask, PlanTaskParentTaskRelation, usePlanTasksService } from 'nekst-api';

export interface CreateSmsPlanTaskFormProps {
  planId: number,
  afterSubmitFunc?: AfterSubmitFunc,
  parentTask?: PlanTask,
  isProceeding?: boolean,
}

export function CreateSmsTaskForm(props: CreateSmsPlanTaskFormProps) {
  const planTaskService = usePlanTasksService();

  let initialData;
  if (props.parentTask) {
    initialData = {
      parentTaskRelation: {
        parentTaskId: props.parentTask.id,
        parentTaskName: props.parentTask.name,
        isProceeding: props.isProceeding,
      } as PlanTaskParentTaskRelation,
    } as PlanTask;
  } else {
    initialData = {} as PlanTask;
  }

  const getTitle = () => {
    if (props.parentTask) {
      if (props.isProceeding) {
        return 'Add Proceeding SMS Task';
      } else {
        return 'Add Dependent SMS Task';
      }
    } else {
      return 'Add SMS task';
    }
  }

  return (
    <BaseSmsTaskForm
      title={getTitle()}
      planId={props.planId}
      submitFormFunc={
        (data) => {
          return planTaskService.createSmsTask(props.planId, data);
        }
      }
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={planTaskService.getSmsTaskValidationSchema()}
      buttons={<SubmitButton text="Save task" key="save" />}
      initialData={initialData}
    />
  );
}

export default function useCreateSmsTaskForm() {
  const popupManager = usePopupManager();

  const openForm = (planId: number) => {
    popupManager.openPopup(
      <PopupForm>
        <CreateSmsTaskForm planId={planId} />
      </PopupForm>,
    );
  };

  return {
    openForm,
  };
}
